export default __webpack_public_path__ + "static/1594-d6e6569e7043bfc5327f0ee980ce74ec.gif";